/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import messageUtil from 'utils/messageUtil'
import { rounding } from 'utils/widgetUtil'

import { setAutoId, AutomationId } from 'utils/automationUtil'
import { TransformedDataSet } from '../../types'

const TooltipWrapper = styled.div`
  padding: ${({ theme }) => theme.padding};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: ${({ theme }) => theme.boxShadow};
  background: ${({ theme }) => theme.background};
  line-height: ${({ theme }) => theme.lineHeight};
  color: ${({ theme }) => theme.color};
  font-size: ${({ theme }) => theme.fontSize};
`

const Divider = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.divider};
  margin: 2px 0;
`

const InfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2px;

  & > :nth-child(1) {
    padding-right: 16px;
  }
  & > :nth-child(2) {
    font-weight: 600;
  }
`

interface ChartTooltipProps {
  pointInfo?: TransformedDataSet
  countType: string
  tooltipTheme?: any
}

const ChartTooltip = (props: ChartTooltipProps) => {
  const { pointInfo, countType, tooltipTheme } = props
  const { t } = useTranslation()

  const thousandFormat = Intl.NumberFormat('en-US')

  return (
    <TooltipWrapper theme={tooltipTheme}>
      <div {...setAutoId(AutomationId.tooltip.header.text)}>{pointInfo?.label}</div>
      <Divider theme={tooltipTheme} />
      <InfoWrapper>
        <span {...setAutoId(AutomationId.tooltip.body.left)}>
          {messageUtil.countType(countType)}
        </span>
        <span {...setAutoId(AutomationId.tooltip.body.right)}>
          {thousandFormat.format(pointInfo?.value ?? 0)}
        </span>
      </InfoWrapper>
      <InfoWrapper>
        <span {...setAutoId(AutomationId.tooltip.body.left)}>{t('share')}</span>
        <span {...setAutoId(AutomationId.tooltip.body.right)}>
          {rounding(pointInfo!.share!, 2)}%
        </span>
      </InfoWrapper>
    </TooltipWrapper>
  )
}

export default ChartTooltip
